import {
    RouterProvider,
    createBrowserRouter,
} from "react-router-dom";
import RootLayout from "../pages";
import HomePage from "../pages/HomePage";
import NoDefault from "../pages/404";
import PortfolioPage from "../pages/PortfolioPage";
import AboutUsPage from "../pages/AboutUsPage";
import ContactUsPage from "../pages/ContactUsPage";

const router = createBrowserRouter([
    {
        path: "/",
        element: <RootLayout />,
        children: [
            {
                path: "/portfolio",
                element: <PortfolioPage />,
            },
            {
                path: "/aboutus",
                element: <AboutUsPage />,
            },
            {
                path: "/contact",
                element: <ContactUsPage />,
            },
            {
                path: "/",
                element: <HomePage />,
            },
            {
                path: "*",
                element: <NoDefault />,
            },
        ],
    },
]);

export default function RoutesProvider(props) {
    return <RouterProvider router={router} >
        {props.children}
    </RouterProvider>
}
